import { Box, Typography, Stack } from "@mui/material";
import type { LoyaltyEventDto } from "Infrastructure/Api/Api";
import { CardChallenges } from "Components/Loyalty/Shared/Challenges/Variants/CardChallenges";
import { CompactChallenges } from "Components/Loyalty/Shared/Challenges/Variants/CompactChallenges";
import type { ChallengeVariant } from "Components/Loyalty/Shared/Challenges/Categories/types";

const VARIANT_TO_COMPONENT = {
  card: CardChallenges,
  compact: CompactChallenges,
};

type Props = {
  challenges: Array<LoyaltyEventDto>;
  title: string;
  isLoading: boolean;
  variant?: ChallengeVariant;
  timeRemaining?: string;
};

export const Challenges = ({
  challenges,
  title,
  isLoading,
  variant = "card",
  timeRemaining,
}: Props) => {
  const ChallengesComponent = VARIANT_TO_COMPONENT[variant];

  return (
    <Stack gap={2}>
      <Box display="flex" justifyContent="space-between" alignItems="center">
        <Typography
          fontSize="1.15rem"
          component="h2"
          fontWeight={600}
          textTransform="uppercase"
        >
          {title}
        </Typography>
        {timeRemaining && (
          <Typography variant="body2" color="text.secondary">
            {timeRemaining}
          </Typography>
        )}
      </Box>
      <ChallengesComponent challenges={challenges} isLoading={isLoading} />
    </Stack>
  );
};
